const text = value => String(value || "").trim();
const missingLast = value => text(value) || "\uffff";

const departmentName = detail =>
  detail.departmentName ||
  (detail.Product && detail.Product.Department && detail.Product.Department.name) ||
  "";

const brandName = detail =>
  detail.brandName ||
  (detail.Product && detail.Product.Brand && detail.Product.Brand.name) ||
  "";

export const shouldSortPrintedInvoiceItems = business =>
  !!(
    business &&
    business.metadata &&
    business.metadata.sortPrintedInvoiceItemsByDepartmentBrand === true
  );

export const sortInvoiceDetailsForPrint = (details, business) => {
  const rows = Array.isArray(details) ? details.slice() : [];
  if (!shouldSortPrintedInvoiceItems(business)) return rows;

  return rows
    .map((detail, originalIndex) => ({ detail, originalIndex }))
    .sort((left, right) => {
      const comparisons = [
        [departmentName(left.detail), departmentName(right.detail)],
        [brandName(left.detail), brandName(right.detail)],
        [left.detail.name, right.detail.name],
      ];

      for (const [leftValue, rightValue] of comparisons) {
        const result = missingLast(leftValue).localeCompare(
          missingLast(rightValue),
          undefined,
          { sensitivity: "base", numeric: true }
        );
        if (result !== 0) return result;
      }

      return left.originalIndex - right.originalIndex;
    })
    .map(row => row.detail);
};
